import { X } from 'lucide-react';
import { getImageUrl } from '../../utils/imageUtils';

/**
 * MediaLightbox - Full-screen media viewer for images, GIFs, and videos
 */
const MediaLightbox = ({ media, onClose }) => {
  if (!media) return null;
  
  const isVideo = media.url?.match(/\.(mp4|webm|mov|avi|ogg|quicktime)$/i);
  const isGif = media.url?.match(/\.gif$/i);
  
  return (
    <div 
      className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 z-10 bg-black/50 rounded-full p-2"
      >
        <X className="w-8 h-8" />
      </button>
      <div 
        className="max-w-[90vw] max-h-[90vh] relative"
        onClick={(e) => e.stopPropagation()}
      >
        {isVideo ? (
          <video 
            src={getImageUrl(media.url)} 
            controls 
            autoPlay
            className="max-w-full rounded-lg"
            style={{ maxWidth: '90vw', maxHeight: '90vh' }}
          />
        ) : (
          <img 
            src={getImageUrl(media.url)} 
            alt="Media full view" 
            className="max-w-full max-h-[90vh] rounded-lg object-contain"
          />
        )}
      </div>
    </div>
  );
};

export default MediaLightbox;
